import React, { useReducer, createContext } from 'react';

export const DrawerContext = createContext({});

const initialState = {
  visible: false,
  title: null,
  loading: false,
  width: 650,
  data: {},
  values: null,
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_DRAWER':
      return {
        ...state,
        visible: true,
        title: payload.title,
        width: payload.width || 650,
        new: payload.new,
        data: payload,
      };
    case 'SET_VALUES':
      return {
        ...state,
        values: payload,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      };
    case 'RESET':
      return initialState;
    default:
      return initialState;
  }
};

const DrawerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DrawerContext.Provider
      value={{
        ...state,
        dispatch,
        setDrawer: (values) =>
          dispatch({ type: 'SET_DRAWER', payload: values }),
        setDrawerValues: (values) =>
          dispatch({ type: 'SET_VALUES', payload: values }),
        setLoading: (val) => dispatch({ type: 'SET_LOADING', payload: val }),
        setClose: () => dispatch({ type: 'RESET' }),
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

export default DrawerProvider;
